import React from "react";
import ProjectOne from "./project-1";
import ProjectTwo from "./project-2";
import ProjectThree from "./project-3";
import ProjectFour from "./project-4";
import ProjectFive from "./project-5";
import ProjectSix from "./project-6";

const Projects = () => {
  return (
    <div className="container w-100 m-auto">
      <h3 className="fw-bold text-center mb-5">PROJECTS</h3>
      <div className="row mb-5 g-3">
        <div className="col-12 col-lg-4">
          <ProjectOne />
        </div>
        <div className="col-12 col-lg-4">
          <ProjectTwo />
        </div>
        <div className="col-12 col-lg-4">
          <ProjectThree />
        </div>
        <div className="col-12 col-lg-4">
          <ProjectFour />
        </div>
        <div className="col-12 col-lg-4">
          <ProjectFive />
        </div>
        <div className="col-12 col-lg-4">
          <ProjectSix />
        </div>
      </div>
    </div>
  );
};

export default Projects;
